import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'member'

const client = new ApiClient(API_NAME)

export default {
  token(memberId) {
    return client.get(`/${BASE_PATH}/${memberId}`, {
      generate: true
    })
  },

  show(memberId) {
    return client.get(`/${BASE_PATH}/${memberId}`, {
      generate: false
    })
  }
}
